import { Fragment, type ReactNode } from 'react'
import { FRIENDS_OF_DXE } from '~/lib/site/constants'
import { Container } from '~/components/ui/Container'
import { DonateSignupBand } from './DonateSignupBand'
import { PageTitle } from '~/components/ui/PageTitle'
import { PageHero } from '~/components/ui/PageHero'

/** Shared layout for the payroll-giving / employer-matching pages. */
export function GivingInfoPage({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle: string
  children: ReactNode
}) {
  return (
    <div>
      <PageHero>
        <Container width="narrow">
          <PageTitle className="mb-2.5 text-center">{title}</PageTitle>
          <h2 className="mt-2.5 mb-5 text-center text-xl font-bold text-fg md:text-[28px]">
            {subtitle}
          </h2>
        </Container>
        <Container width="narrow" className="pb-[45px]">
          {children}
          <h3 className="mt-12 mb-2 text-2xl font-bold text-fg">
            Our information
          </h3>
          <p className="text-lg leading-[26px]">
            <strong>Mailing address</strong>
            <br />
            {FRIENDS_OF_DXE.legalName}
            {FRIENDS_OF_DXE.addressLines.map((line) => (
              <Fragment key={line}>
                <br />
                {line}
              </Fragment>
            ))}
            <br />
            <br />
            <strong>Legal name</strong>
            <br />
            {FRIENDS_OF_DXE.legalName}
            <br />
            <br />
            <strong>EIN</strong>
            <br />
            {FRIENDS_OF_DXE.ein}
            <br />
            <br />
            <strong>Contact</strong>
            <br />
            Email: {FRIENDS_OF_DXE.email}
            <br />
            Phone: {FRIENDS_OF_DXE.phone}
          </p>
        </Container>
      </PageHero>
      <DonateSignupBand />
    </div>
  )
}
